/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetAvailableCompanyDocumentsResponse = {
  type: 'all-of',
  contains: [{
    type: 'Response',
  }, {
    properties: {
      data: {
        type: 'array',
        contains: {
          type: 'CompanyDocumentConfig',
        },
      },
    },
  }],
} as const;
